const Backbone = require('backbone');
const config = require('config');

const parameters = new Backbone.Model();

// set parameters
parameters.set({
  api_authorization_header: config.api.authorization_header,
  api_base_url: config.api.base_url,
  api_storage_url: config.api.storage_url,
  idle_time: config.idle.minutes,
  weeks_to_display: config.weeks.display,
  client_token: null
});

module.exports = parameters;



// WEBPACK FOOTER //
// ./src/data/parameters.js